import { Button } from "@mui/material";
import React from "react";

function Invoice() {
  return (
    <div className="section-process-content invoice-bg-con d-flex justify-center items-center ">
      <div className="bankDetails-con w-3/4 z-10 h-96 overflow-auto">
        <h3 className="bg-blue-950 text-white mb-3 mt-2 text-center text-3xl">
          <b> Invoice </b>
        </h3>

        <div className="bg-slate-50 p-4 mb-3 applcnt-pro-bioData-inner-con rounded-lg">
          <ul>
            <li>
              <b>Date of Payment:</b> <span> 12th Jun 2024 </span>
            </li>
            <li>
              <b>Processing Fee:</b> <span>N4,000 </span>
            </li>
            <li>
              <b>Paid For:</b> <span>Merit Base </span>
            </li>
            <li>
              <b>Reference No:</b> <span> 136936 </span>
            </li>
          </ul>
          <Button variant="contained">Send To Mail</Button>
        </div>
        <div className="bg-slate-50 p-4 mb-3 applcnt-pro-bioData-inner-con rounded-lg">
          <ul>
            <li>
              <b>Date of Payment:</b> <span> 12th Jun 2024 </span>
            </li>
            <li>
              <b>Processing Fee:</b> <span>N4,000 </span>
            </li>
            <li>
              <b>Paid For:</b> <span>Merit Base </span>
            </li>
            <li>
              <b>Reference No:</b> <span> 136936 </span>
            </li>
          </ul>
          <Button variant="contained">Send To Mail</Button>
        </div>
        <div className="bg-slate-50 p-4 mb-3 applcnt-pro-bioData-inner-con rounded-lg">
          <ul>
            <li>
              <b>Date of Payment:</b> <span> 12th Jun 2024 </span>
            </li>
            <li>
              <b>Processing Fee:</b> <span>N4,000 </span>
            </li>
            <li>
              <b>Paid For:</b> <span>Merit Base </span>
            </li>
            <li>
              <b>Reference No:</b> <span> 136936 </span>
            </li>
          </ul>
          <Button variant="contained">Send To Mail</Button>
        </div>
      </div>
    </div>

    // <div className="section-process-content upload-doc-con h-full flex justify-center">
    //   <div className="w-5/6 con-main-table-inner">

    //   </div>
    // </div>
  );
}

export default Invoice;
